import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'artist',
	prefix: 'artist',
	key: 'artist_id',
	fields: {
		artist_id: Model.SCHEMA_NUMBER,
		artist_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				artist_id: this.get_id(),
				artist_name: this.rawData().artist_name
			}
		}
	}
})
